// import React, { Component } from "react";
import React from "react";
import MatBtn from "./matBtn";
import project from "../config";
const BodenFarbeIcon = require(`../assets/${project.assets}/img/BodenFarbeIcon.png`);
const WandFarbeIcon = require(`../assets/${project.assets}/img/WandFarbeIcon.png`);
const DeckenFarbe = require(`../assets/${project.assets}/img/DeckenFarbe.png`);
const LeistenIcon = require(`../assets/${project.assets}/img/LeistenIcon.png`);
const badeWaneIcon = require(`../assets/${project.assets}/img/badeWaneIcon.png`);

const Icon = ({ matName }) => {
	let icon;
	switch (matName) {
		case "Boden":
			icon = <img src={BodenFarbeIcon} width="18px" alt={matName} />;
			break;
		case "Wandfarbe":
			icon = <img src={WandFarbeIcon} width="18px" alt={matName} />;
			break;
		case "Deckenfarbe":
			icon = <img src={DeckenFarbe} width="18px" alt={matName} />;
			break;
		case "Sockelleiste":
			icon = <img src={LeistenIcon} width="18px" alt={matName} />;
			break;
		case "Badezimmer Ausstattung":
			icon = <img src={badeWaneIcon} width="18px" alt={matName} />;
			break;

		default:
			break;
	}
	return icon;
};

function MaterialPack(props) {
	let {
		id,
		name,
		collapseHandle,
		isOpened,
		choices,
		matBtnCMD,
		objectName,
		changeObj,
	} = props;

	function addObjectName(choise) {
		matBtnCMD({ ueCMD: objectName + "," + choise.unreal_id, id: id, choise });
	}

	return (
		<div
			className={
				"material-container " + (isOpened === true ? "material--expanded" : "")
			}
		>
			<div
				className="material-Header"
				onClick={() => {
					collapseHandle(id);
				}}
			>
				<Icon matName={name} />
				<span className="matRowName">{name}</span>
				<span id="matRowPrice" className="matRowPrice">
					{changeObj.choice.surcharge.toLocaleString("de-DE", {
						style: "currency",
						currency: "EUR",
						maximumFractionDigits: 2,
					})}
				</span>
				<div className="matRowArrow"></div>
			</div>
			<div className="material-body">
				{choices.map((pack, id) => (
					<MatBtn key={id} id={id} choise={pack} matBtnCMD={addObjectName} />
				))}
			</div>
		</div>
	);
}

export default MaterialPack;
